// src/Progress.js
import React from 'react';
import './Progress.css'; // Optional: For any custom styling

const Progress = ({ isLoading ,size}) => {
  return (
    <div className="progress-container">
       <img  src="/assets/images/progress.gif" alt="Loading..." className="progress-gif" style={{width:size}} />
    </div>
  );
};

export default Progress;
